import { TypesError } from "./errors";
export var isRequired = {
    func: function isRequired(value) {
        if (typeof value === "undefined") {
            throw new TypesError("value is not defined");
        }
        return value;
    },
};
export var defaults = {
    isFactory: true,
    func: function defaults(value, defaultValue) {
        if (value) {
            return value;
        }
        return defaultValue;
    },
};
//# sourceMappingURL=ChainableTypes.js.map